import { useCallback } from 'react';
import useCommonImageUploader from '@/ueshook/batchToolsHook/useImageUpload/useCommonImageUploader';
import { useImageProcessing } from '../context/ImageProcessingContext';
import type { ImageStatus } from '../context/ImageProcessingContext';

interface UseImageUploaderProps {
  from?: string;
}

/**
 * 照片修复专用图像上传Hook
 * @description 只使用公共Hook，无特殊业务逻辑
 */
export function useImageUploader(props: UseImageUploaderProps = {}) {
  const { from = 'ImageUploader' } = props;
  const { ImageState, dispatchImage } = useImageProcessing();

  // 创建照片修复专用的初始状态工厂函数
  const createInitialImageStatus = (
    file: File,
    imageId: string
  ): ImageStatus => {
    return {
      localImgId: imageId,
      localImgName: file.name,
      localImgType: file.type,
      localImgSize: { width: 0, height: 0 },

      generateStatus: 'generating',
      generateStatusText: '',
      localImgUrl: '',
      localFile: file,

      uploadStatus: 'ready',
      uploadStatusText: '',
      uploadUrl: null,
      uploadId: null,

      finalStatus: 'ready',
      batchTaskId: null,
      outputImageUrl: null,
      outputThumbnail: null,
      outputError: null,
      outputRate: null,

      showImgState: 'Original',

      outputHalfUrl: '',
      outputBlurUrl: '',
      isLockedOutput: true,
      outputErrorCode: '',
    };
  };

  // 使用公共的图像上传Hook
  const { uploadOriginalImages, handleImageUploadInit } =
    useCommonImageUploader({
      from: `image_repair_${from}`,
      ImageState,
      dispatchImage,
      createInitialImageStatus,
    });

  /**
   * 检查并上传所有需要上传的图像
   */
  const checkAndUploadImages = useCallback(
    async (_form?: string) => {
      await uploadOriginalImages();
    },
    [uploadOriginalImages]
  );

  return { handleImageUploadInit, checkAndUploadImages };
}

export default useImageUploader;
